import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { useFulfillOrder as useFulfillOrderClient } from './order';
import { z } from 'zod';
import { PostOrderFulfillRequestSchema } from '@schuettflix/interfaces';
import { useQueryErrorHandler } from '@/shared/hooks/useQueryErrorHandler.ts';

export const useFulfillOrderMutation = (
    orderId: string,
    hookOptions?: Pick<UseMutationOptions<any, any, z.input<typeof PostOrderFulfillRequestSchema>>, 'onSuccess'>
) => {
    const { handleMutationErrors } = useQueryErrorHandler();
    const { fulfillOrder } = useFulfillOrderClient();

    return useMutation({
        ...handleMutationErrors,
        mutationFn: (payload: z.input<typeof PostOrderFulfillRequestSchema>) => fulfillOrder(orderId, payload),
        ...hookOptions,
    });
};
